import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getAbsenceStateTranslationKey(state: Enums<"absenceState">): TranslationKey {
	switch (state) {
		case "pending":
			return "absences.state.pending";
		case "approved":
			return "absences.state.approved";
		case "rejected":
			return "absences.state.rejected";
		case "cancelled":
			return "absences.state.cancelled";
		default:
			return "absences.state.pending";
	}
}
